<template>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="PTM Scheduling Compliance Report">
        <v-card-actions>
        </v-card-actions>
        <v-card flat class="px-2">
          <form >
            <v-row>
              <v-col cols="12" lg="3">
                <label class="body-2 font-weight-medium">Zone</label>
                <v-autocomplete
                  placeholder="--Select--"
                  v-model="selectzone"
                  item-value="name"
                  :items="zones"
                  key="id"
                  item-text="name"
                  @change="getZoneList()"
                  :search-input.sync="zoneSearch"
                />
              </v-col>
              <v-col cols="12" lg="3" v-if="!isFranchiseeUser">
                <label class="body-2 font-weight-medium">Center</label>
                <v-autocomplete
                    multiple
                    placeholder="--Select--"
                    v-model="selectfranchisee"
                    item-value="id"
                    :items="franchiseeArr"
                    key="id"
                    item-text="companyName"
                  :search-input.sync="franchiseeSearch "
                  @change="handleZoneSelect"
                />
              </v-col>
              <v-col cols="12" lg="3">
                <label class="body-2 font-weight-medium">Term</label>
                <v-autocomplete
                  placeholder="--Select--"
                  item-value="id"
                  key="id"
                  item-text="name"
                  multiple
                  :items="terms"
                  v-model="term"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3">
                <label class="body-2 font-weight-medium">Program</label>
                <v-autocomplete
                    placeholder="--Select--"
                    name="classSelect"
                    v-model="selectedClassID"
                    v-on:change="changeSections()"
                    item-value="id"
                    :items="classes"
                    key="id"
                    item-text="name"
                  >
                  </v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3">
                <label class="body-2 font-weight-medium">PTM Status</label>
                <v-autocomplete
                  placeholder="--Select--"
                  item-value="id"
                  key="id"
                  item-text="name"
                  :items="status"
                  v-model="ptmstatus"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                  <div class="inside">
                    <v-btn color="success" elevation="1" type="submit" @click.prevent="onApplyFilters">
                      Apply Filters
                    </v-btn>
                    <v-btn
                      class="ml-4"
                      height="35"
                      small
                      elevation="1"
                      type="reset" @click="resetAll()">
                      <v-icon left size="18"> mdi-restart</v-icon>
                      Reset
                    </v-btn>
                    <v-btn color="primary"
                      class="ml-4"
                      height="35"
                      small
                      elevation="1"  @click="downloadCSV"
                    >
                      Download CSV
                    </v-btn>
                  </div>
                </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component >
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            Total Records : {{ total }}
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card-text>
        <v-divider class=" my-0 " />
        <v-data-table
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="ptmLogRows"
          :search="search"
        >
        <template v-slot:item.academicStartDate="{ item }">
            {{ formatDateOnly(item.academicStartDate) }}
        </template>
        <template v-slot:item.ptmScheduledDate="{ item }">
            {{ formatDateOnly(item.ptmScheduledDate) }}
        </template>
        <template v-slot:item.lastUpdatedAt="{ item }">
            {{ formatDateOnly(item.lastUpdatedAt) }}
        </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
      </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </template>

<script>
import constants from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
import axios from 'axios'
import _ from 'lodash'
import stores from '@/stores'
export default {
  name: 'PTMmaintainlogReports',
  components: {
    MaterialCard, VCardComponent
  },
  data () {
    return {
      search: '',
      isLoading: false,
      academicYears: [],
      academicYearID: '',
      franchiseeArr: [],
      calendarTypeArray: [],
      inProgress: false,
      franchiseeID: [],
      total: 0,
      selectedSectionID: [],
      selectfranchisee: '',
      selectedClassID: '',
      classes: [],
      term: null,
      ptmstatus: null,
      selectzone: '',
      zoneSearch: '',
      franchiseeSearch: '',
      centerList: [],
      franchiseearr: [],
      terms: [],
      status: [
        { id: 'Scheduled within 30 days', name: 'Scheduled within 30 days' },
        { id: 'Scheduled after 30 days', name: 'Scheduled after 30 days' },
        { id: 'Not Scheduled', name: 'Not Scheduled' }
      ],
      headers: [
        { text: 'Zone Name', value: 'region', sortable: true },
        { text: 'Center Name', value: 'centerName', sortable: true },
        { text: 'Term', value: 'term', sortable: true },
        { text: 'Program Name', value: 'programName', sortable: true },
        { text: 'Academic Start Date', value: 'academicStartDate', sortable: true },
        { text: 'PTM Scheduled Date', value: 'ptmScheduledDate', sortable: true },
        { text: 'Days from Term Start', value: 'daysFromTermStart', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Last Updated By', value: 'lastUpdatedBy', sortable: true },
        { text: 'Last Updated On', value: 'lastUpdatedAt', sortable: true }
      ],
      isCenterHeadUser: false,
      ptmLogRows: [],
      zones: [],
      isFranchiseeUser: false
    }
  },
  async created () {
    this.isFranchiseeUser = stores.user.me.isFranchiseeUser
    await this.getYear()
    await this.onFranchiseeChange()
    await this.getZoneDetails()
    await this.getClassList()
    await this.getFranchiseeList()
    await this.fetchPTMComplianceLog()
    await this.termList()
    if (this.isFranchiseeUser && this.zones.length > 0) {
      this.selectzone = this.zones[0].name
      await this.getZoneList()
      if (this.franchiseeArr.length > 0) {
        this.selectfranchisee = this.franchiseeArr[0].id
      }
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      // franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getZoneList: async function () {
      try {
        this.isLoading = true
        let zone = []
        if (this.selectzone) {
          zone = [this.selectzone]
        }
        if (zone.length > 0) {
          const response = await http.post(
            `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
            {
              zone: zone
            }
          )
          let data = response.data
          this.franchiseeArr = _.map(data, (e) => {
            if (e.id) {
              if (e.id.toString().length === 1) {
                e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
              } else if (e.id.toString().length === 2) {
                e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
              } else {
                e.companyName = `${'(' + e.id + ')'} ` + e.companyName
              }
              e.companyName = e.region
                ? e.companyName + `${' (' + e.region + ')'}`
                : e.companyName
            }
            return e
          })
        } else {
          this.franchiseeArr = []
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )
        this.zones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    changeSections: async function () {
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        if (sectionarray) {
          this.classWiseSections = sectionarray.studentSections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/student/all-count`
        )
        if (data) {
          this.classes = data
          this.sections = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    handleZoneSelect () {
      this.franchiseeSearch = ''
    },
    resetAll: async function () {
      this.selectzone = ''
      this.selectfranchisee = ''
      this.selectedClassID = ''
      this.term = null
      this.ptmstatus = null
      await this.getClassList()
      await this.fetchPTMComplianceLog()
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee/active`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    formatDateOnly (dateString) {
      if (!dateString) return ''
      const dateObj = new Date(dateString)
      const yyyy = dateObj.getFullYear()
      const mm = String(dateObj.getMonth() + 1).padStart(2, '0')
      const dd = String(dateObj.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    async onApplyFilters () {
      await this.fetchPTMComplianceLog()
    },
    formatRegion (region) {
      if (!region) return ''
      return region.charAt(0).toUpperCase() + region.slice(1).toLowerCase()
    },
    async fetchPTMComplianceLog () {
      try {
        this.isLoading = true
        const payload = {
          region: this.selectzone ? this.selectzone : null,
          franchiseeID: this.selectfranchisee.length ? this.selectfranchisee : null,
          academicYearID: this.academicYearID,
          academicTermID: this.term ? this.term : null,
          classID: this.selectedClassID ? this.selectedClassID : null,
          ptmStatus: this.ptmstatus ? this.ptmstatus : null
        }
        const { data } = await axios.post(
          `${constants.API_URL}/api/grade-module/ptm/scheduling-compliance-report`,
          payload
        )
        if (data && data.data) {
          data.data = data.data.map(row => ({
            ...row,
            region: this.formatRegion(row.region)
          }))
        }
        this.total = data.totalRecords
        this.ptmLogRows = data.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('Error fetching PTM log', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    termList: async function () {
      try {
        const studentclasses = await http.get(`${constants.API_URL}/api/students/class`)
        this.classes = studentclasses.data.rows
        const Terms = await http.get(`${constants.API_URL}/api/grade-module/academic-terms`)
        this.terms = Terms.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    downloadCSV () {
      if (!this.ptmLogRows || !this.ptmLogRows.length) {
        this.errMsg('No data to download.')
        return
      }
      const headers = [
        'Zone Name',
        'Center Name',
        'Term',
        'Program Name',
        'Academic Start Date',
        'PTM Scheduled Date',
        'Days from Term Start',
        'Status',
        'Last Updated By',
        'Last Updated On'
      ]
      const csvRows = [
        headers.join(',')
      ]
      this.ptmLogRows.forEach(row => {
        csvRows.push([
          `"${row.region || ''}"`,
          `"${row.centerName || ''}"`,
          `"${row.term || ''}"`,
          `"${row.programName || ''}"`,
          `"${this.formatDateOnly(row.academicStartDate) || ''}"`,
          `"${this.formatDateOnly(row.ptmScheduledDate) || ''}"`,
          `"${row.daysFromTermStart !== null ? row.daysFromTermStart : ''}"`,
          `"${row.status || ''}"`,
          `"${row.lastUpdatedBy || ''}"`,
          `"${this.formatDateOnly(row.lastUpdatedAt) || ''}"`
        ].join(','))
      })
      const csvContent = csvRows.join('\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', 'PTM_Scheduling_Compliance_Report.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>
